import { AccountAspectType } from "@oysterhr/identity/AccountAspectContext"
import { AuthorizationRoleEnumType } from "@oysterhr/schema"

export const EXTERNAL_ROLES = Object.values(AuthorizationRoleEnumType).filter(role =>
  role.includes("EXTERNAL_"),
)

export enum Segment {
  STAFF = "STAFF",
  NONE = "NONE",
  FULL_TIME_EMPLOYEE = "FULL_TIME_EMPLOYEE",
  CONTRACTOR = "CONTRACTOR",
  COMPANY_ADMIN = "COMPANY_ADMIN",
  MANAGER = "MANAGER",
  CUSTOMER = "CUSTOMER",
  EXTERNAL = "EXTERNAL",
}

export const roleForTeamMember: Record<string, Segment> = {
  [AccountAspectType.EMPLOYEE]: Segment.FULL_TIME_EMPLOYEE,
  [AccountAspectType.CONTRACT]: Segment.CONTRACTOR,
}
